import { WindowBreakpoints } from '@dustin-web/microsite-config'
import classNames from 'classnames'
import Link from 'next/link'
import { useTranslations } from 'packages/microsite-components/src/hooks'
import { Icon } from 'packages/microsite-components/src/icon-library'
import { useTrackingOnScreen } from '@dustin-web/microsite-components/src/on-screen/'
import { DigitalData } from 'packages/microsite-components/src/utils/digital-data'
type Props = {
  breakpoints: WindowBreakpoints
}

export default function TakebackCategoryBannerCard({ breakpoints }: Props) {
  const { translate } = useTranslations()
  const ref = useTrackingOnScreen(() => {
    DigitalData.pushViewPromotion({
      creative_name: 'takeback',
      promotion_name: 'category-page_banner',
      creative_slot: 'service_icons',
      promotion_id: '',
    })
  })

  const onClick = (selectedService: string) => {
    DigitalData.pushSelectPromotion({
      promotion_id: '',
      creative_name: selectedService,
      promotion_name: 'category-page_banner',
      creative_slot: 'service_icons',
    })
  }

  return (
    <article className="u-h-100 col-12 u-bg-dark-green u-color-light-green u-radius-4 link-opacity-80-hover--slow">
      <Link
        className="d-flex u-h-100 u-px-16 u-py-16 u-px-lg-24 u-py-lg-24 a-no-styling justify-content-between align-items-lg-center"
        href={translate('Link_Takeback')}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => onClick('takeback')}>
        <div className="d-flex flex-column flex-lg-row flex-md-row gap-24">
          <Icon
            className={classNames('i-56 u-color-green', {
              'i-80': breakpoints.min.MD && breakpoints.max.LG,
              'i-190': breakpoints.min.LG,
            })}
            name="leaf"
          />
          <div className="align-self-md-center align-self-lg-start">
            <header ref={ref}>
              <h3 className={classNames('u-color-green u-pb-4', { h5: breakpoints.max.LG })}>
                Takeback
              </h3>
              <p className={classNames('h3', { h2: breakpoints.min.LG })}>
                {translate('Takeback_Card_Subheader')}
              </p>
            </header>
            <p className="u-fs-14 u-fs-lg-16 col-lg-10 u-pl-0">
              {translate('Takeback_Card_Information')}
            </p>
          </div>
        </div>
        <Icon
          className={classNames('i-24 align-self-end', { 'i-32': breakpoints.min.LG })}
          name="arrow-right"
        />
      </Link>
    </article>
  )
}
